import React from "react";

import { Button } from "../../../components/Field";
import { formatAmount } from "../../../helpers/format";
import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Title from "../../../components/Title";

import style from "./style.module.css";

export default function Card({ item = {}, size, backgroundColor }) {
    const {
        title = "",
        description = "",
        price = "",
        button_label = "",
        button_url = ""
    } = item;
    const cardName = backgroundColor === "white" ? "ticketCardWrap" : "eventCardWrap";
    const color = cardName === "eventCardWrap" ? "buttonPrimaryWithOutBg" : "";

    return (
        <div className={`${style.ticketCard} ${style[size]}`}>
            <div className={`${style[cardName]} ${style.ticketCardInner}`}>
                <Link to={button_url} className={style.fullBlock} />
                {
                    title !== "" && (
                        <div className={style.titleCard}>
                            <Title className="fontTeko" transform="uppercase" tag="h1">{title}</Title>
                        </div>
                    )
                }
                {
                    description !== "" && (
                        <div className={style.subTitleCard}>
                            <Text text={description} className="size23"/>
                        </div>
                    )
                }
                {
                    price !== "" && (
                        <div className={style.cardAmount}>
                            <Title className="fontTeko" transform="uppercase" tag="h2">{formatAmount(price, "£")}</Title>
                        </div>
                    )
                }
                {
                    button_label !== "" && button_url !== "" && (
                        <div className={style.cardButton}>
                            <Button label={button_label} color={color} link={button_url} />
                        </div>
                    )
                }
            </div>
        </div>
    )
}